module.exports = __webpack_public_path__ + "img/bg_loaded.e2b20710.png";